module.exports = __webpack_public_path__ + "static/media/riskpic3.27c10a49.png";